/** Load an image from a URL (object URL or data URL). */
export function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', reject);
    image.setAttribute('crossOrigin', 'anonymous');
    image.src = src;
  });
}

export interface PixelCrop {
  x: number;
  y: number;
  width: number;
  height: number;
}

/** Crop the source image to a square JPEG File for avatar upload. */
export async function getCroppedAvatarFile(
  imageSrc: string,
  pixelCrop: PixelCrop,
  fileName = 'avatar.jpg',
  outputSize = 512,
): Promise<{ file: File; previewUrl: string }> {
  const image = await loadImage(imageSrc);
  const canvas = document.createElement('canvas');
  canvas.width = outputSize;
  canvas.height = outputSize;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Could not create canvas context');

  ctx.imageSmoothingQuality = 'high';
  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    outputSize,
    outputSize,
  );

  const blob = await new Promise<Blob>((resolve, reject) => {
    canvas.toBlob(
      result => (result ? resolve(result) : reject(new Error('Failed to crop image'))),
      'image/jpeg',
      0.92,
    );
  });

  const file = new File([blob], fileName.replace(/\.\w+$/, '.jpg'), { type: 'image/jpeg' });
  const previewUrl = URL.createObjectURL(blob);
  return { file, previewUrl };
}
